import { useEffect, useState } from "react";
import { useAuthContext } from "../../context/AuthContext";
import { Link } from "react-router-dom";
import getLatestJobPostings from "../../apis/getLatestJobPostings";
import BlockHeader from "../Headers/BlockHeader";
import { AlertInfo } from "../Alerts/Alert";
import ComponentLoader from "../Loader/ComponentLoader";
import FirmLogo from "../Images/FirmLogo";

const ActiveJobs = () => {
  const { userDetails } = useAuthContext();
  const user_slug = JSON.parse(userDetails).user_slug;
  const [isLoading, setIsLoading] = useState(true);
  const [data, setData] = useState(false);

  useEffect(() => {
    if (user_slug !== undefined) {
      getFavoriteProfiles();
    }
  }, [user_slug]);

  const getFavoriteProfiles = () => {
    Promise.all([getLatestJobPostings(user_slug, "")])
      .then(async ([data]) => {
        if (data?.data?.status === 0) {
          await setIsLoading(false);
        } else {
          if (data?.data?.job_list) {
            setData(data?.data?.job_list);
            setIsLoading(false);
          } else {
            setIsLoading(false);
          }
        }
      })
      .catch((err) => {
        setIsLoading(false);
        console.log(err);
      });
  };

  const displayList = () => {
    return (
      <>
        <div className="table-responsive  table-wrapper scrollable">
          <table className="table table-bordered">
            <thead className="no-border">
              <tr className="border-top-0">
                <th>Title</th>
                <th>Posted on</th>
                <th>Requestor</th>
              </tr>
            </thead>
            <tbody>
              {data.map((item, index) => (
                <tr key={index.toString()}>
                  <td className="align-middle">
                    <Link to={"job/details/" + item.job_slug}>
                      <div
                        className="fw-semibold text-truncate text-decoration-none text-dark"
                        title={item?.job_title}
                      >
                        {/* #{item.job_id}{" "} */}
                        {item?.job_title?.length > 50
                          ? item?.job_title.substring(0, 49) + "..."
                          : item?.job_title}
                      </div>
                      <div>
                        {item.location_requirement && (
                          <span className="text-secondary text-sm">
                            {/* <i className="bi bi-geo-alt-fill me-1 text-muted"></i> */}
                            {item.location_requirement}
                          </span>
                        )}
                      </div>
                    </Link>
                  </td>
                  <td className="align-middle">
                    <div className="text-muted">{item?.created_on}</div>
                  </td>
                  <td className="align-middle">
                    {item?.user_primary_role !== "4" ? (
                      <FirmLogo url={item?.firm_logo} />
                    ) : (
                      <span className="text-sm">{item?.user_email}</span>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </>
    );
  };

  const displayContent = () => {
    if (!data) {
      return <AlertInfo message="Nothing to display!" />;
    } else {
      return displayList();
    }
  };

  const checkIsLoading = () => {
    if (isLoading) {
      return <ComponentLoader />;
    } else {
      return displayContent();
    }
  };

  return (
    <div class="card">
      <div className="card-body">
        <BlockHeader
          title={"Active jobs"}
          subText={"All active job listings"}
        />
        {checkIsLoading()}
      </div>
    </div>
  );
};

export default ActiveJobs;
